import moment, { Moment } from 'moment/moment'

export interface UserMainGoalProgramPayload {
    id: number
    name: string
    description: string
    workout_count: number
    workout_types: string[]
    end_date: string | null
}

export interface UserMainGoalPayload {
    id: number
    title: string
    type: string
    plan_type: string | null
    start_at: string | null
    end_at: string | null
    distance: string | null
    target_time: string | null
    stroke: string | null
    details: Record<string, any> | null
    preferences: Record<string, any> | null
    duration_formatted: string | null
    status: string
    program_id: number | null
    program: UserMainGoalProgramPayload | null
    program_card: Record<string, any> | null
    alternative_programs: any[]
}

export class UserMainGoal {

    id: number
    title: string
    type: string
    planType: string | null
    startAt: Moment | null
    endAt: Moment | null
    distance: string | null
    targetTime: string | null
    stroke: string | null
    details: Record<string, any> | null
    preferences: Record<string, any> | null
    durationFormatted: string | null
    status: string
    programId: number | null
    program: UserMainGoalProgramPayload | null
    programCard: Record<string, any> | null
    alternativePrograms: any[]

    constructor(data: UserMainGoalPayload) {
        this.id = data.id
        this.title = data.title
        this.type = data.type
        this.planType = data.plan_type || null
        this.startAt = data.start_at ? moment(data.start_at) : null
        this.endAt = data.end_at ? moment(data.end_at) : null
        this.distance = data.distance || null
        this.targetTime = data.target_time || null
        this.stroke = data.stroke || null
        this.details = data.details || null
        this.preferences = data.preferences || null
        this.durationFormatted = data.duration_formatted || null
        this.status = data.status
        this.programId = data.program_id || null
        this.program = data.program || null
        this.programCard = data.program_card || null
        this.alternativePrograms = data.alternative_programs || []
    }

    fill(data: UserMainGoalPayload): this {
        this.id = data.id
        this.title = data.title
        this.type = data.type
        this.planType = data.plan_type || null
        this.startAt = data.start_at ? moment(data.start_at) : null
        this.endAt = data.end_at ? moment(data.end_at) : null
        this.distance = data.distance || null
        this.targetTime = data.target_time || null
        this.stroke = data.stroke || null
        this.details = data.details || null
        this.preferences = data.preferences || null
        this.durationFormatted = data.duration_formatted || null
        this.status = data.status
        this.programId = data.program_id || null
        this.program = data.program || null
        this.programCard = data.program_card || null
        this.alternativePrograms = data.alternative_programs || []
        return this
    }

    exists(): boolean {
        return !!this.id
    }

    unset(): this {
        return this.fill(<any>{})
    }
}